export default __webpack_public_path__ + "static/mainImage-d15f888fee26d7e4e3e11360a4989cbb.jpg";